import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "history_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  key: 0,
  class: "history_body_nr"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "time"
};
const _hoisted_6 = {
  class: "remark"
};
const _hoisted_7 = {
  class: "fill"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = ["src", "onClick"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  key: 1,
  style: {
    "width": "40rem",
    "margin-top": "20%"
  },
  src: "https://www.mimodental.com/assets/imgData/img/new/que.png"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "历史记录", -1))]), $setup.get_data.length != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.get_data, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "get_dataList",
      key: index
    }, [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/delete.png",
      class: "delete_icon",
      onClick: $event => $setup.deleteBenefitActivityRecord(item.id),
      alt: ""
    }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(item.createTime), 1), _createElementVNode("span", _hoisted_6, _toDisplayString(item.remark), 1), _createElementVNode("div", _hoisted_7, [item.imageUrl ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("img", {
      src: item.imageUrl,
      onClick: $event => $setup.look(item.imageUrl),
      alt: ""
    }, null, 8, _hoisted_9)])) : _createCommentVNode("", true), item.videoUrl ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      onClick: $event => $setup.look(item.videoUrl)
    }, _cache[2] || (_cache[2] = [_createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/vido_icon.png",
      alt: ""
    }, null, -1), _createElementVNode("img", {
      src: "https://www.mimodental.com/assets/imgData/imgs/bf.png",
      alt: "",
      class: "bf_icon"
    }, null, -1)]), 8, _hoisted_10)) : _createCommentVNode("", true)])]);
  }), 128))])) : (_openBlock(), _createElementBlock("img", _hoisted_11))]);
}